function l(t) {
  const { lineHeight: e, fontSize: n } = window.getComputedStyle(t);
  return e === "normal" ? parseInt(n, 10) * 1.2 : parseFloat(e);
}
function s(t) {
  let e;
  const n = document.createTreeWalker(t, NodeFilter.SHOW_TEXT, null, !1);
  for (; e = n.nextNode(); )
    if (e && e.childNodes && !e.childNodes.length) {
      e = e;
      break;
    }
  return e;
}
function a(t, e, n) {
  let { textContent: i } = t;
  if (t.textContent = "", e.clientHeight > n)
    return !1;
  const r = i.split(" ");
  for (; r.pop(); ) {
    if (t.textContent = r.join(" "), e.clientHeight <= n) {
      t.textContent = i;
      break;
    }
    i = t.textContent;
  }
  let { length: o } = i;
  for (; o > 1; )
    if (i = i.substring(0, --o), t.textContent = `${i}…`, e.clientHeight <= n)
      return !0;
  return !1;
}
function c(t, e) {
  const n = l(t), i = Math.round(n * e);
  if (t.clientHeight <= i)
    return !1;
  const r = s(t);
  return a(r, t, i);
}
function u({ element: t, lineCount: e = 1 } = {}) {
  return new Promise((n) => {
    t || n(!1), typeof t.style.webkitLineClamp > "u" && n(c(t, e)), t.style.overflow = "hidden", t.style.textOverflow = "ellipsis", t.style.webkitBoxOrient = "vertical", t.style.display = "-webkit-box", t.style.webkitLineClamp = e, requestAnimationFrame(() => {
      n(t.scrollHeight - 2 > t.clientHeight);
    });
  });
}
export {
  u as lineClamp
};
//# sourceMappingURL=line-clamp.js.map
